/**
 * Карточки Маркета на одном коде (ТЗ §4.9): у каждой своё имя в шапке и свой стартовый раздел, остальные разделы
 * те же. Код карточки приходит с сервера в bootstrap (портал ставил приложение из этой карточки).
 */
export interface CardMeta { title: string; sub: string; preConnect: string[] }
export const CARDS: Record<string, CardMeta> = {
  main: { title: 'Метрика продаж', sub: 'сделки из CRM в Яндекс', preConnect: [] },
  // Формы работают и без Яндекса: заявки с сайта идут в CRM с источником, Метрика подключается потом.
  forms: { title: 'Формы сайта в CRM', sub: 'заявки с источником', preConnect: ['sources'] },
  direct: { title: 'Окупаемость Директа', sub: 'расход против выручки', preConnect: [] },
};
export const cardMeta = (card: string | undefined): CardMeta => CARDS[card ?? 'main'] ?? CARDS.main;
